import { render, staticRenderFns } from "./GoodsPopup.vue?vue&type=template&id=63338c64&scoped=true"
import script from "./GoodsPopup.vue?vue&type=script&lang=js"
export * from "./GoodsPopup.vue?vue&type=script&lang=js"
import style0 from "./GoodsPopup.vue?vue&type=style&index=0&id=63338c64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63338c64",
  null
  
)

export default component.exports